module.exports = __webpack_public_path__ + "static/2_1_search-1_PT-6f9ef6f0e404a7e2803d6e839e5075af.svg";